import React from 'react';
import { useFormContext } from 'react-hook-form';
import { RevenuePaymentTypeFilter } from '@trnsact/trnsact-shared-types';
import { SelectField } from 'components/form/rhf';
import { FinanceFilters } from '../types';

const options = [
  { label: 'All', value: RevenuePaymentTypeFilter.All },
  { label: 'Cash', value: RevenuePaymentTypeFilter.Cash },
  { label: 'Credit Line', value: RevenuePaymentTypeFilter.CreditLine },
  { label: 'Financing', value: RevenuePaymentTypeFilter.Financing },
];

export const FinancePaymentType = () => {
  const { control } = useFormContext<FinanceFilters>();

  return (
    <SelectField
      size="small"
      variant="outlined"
      name="PAYMENT_TYPE"
      label="Payment Type"
      control={control}
      options={options}
    />
  );
};
